class ProductTabs extends HTMLElement {
  constructor() {
    super()
    this.tabs = []
    this.init()
  }

  // eslint-disable-next-line class-methods-use-this
  closeOpenedTab(tab) {
    const summary = tab.querySelector('summary')
    tab.removeAttribute('open')
    summary.setAttribute('aria-expanded', false)
  }

  getTabIndex(tab) {
    return Array.from(this.tabs).findIndex((el) => el === tab)
  }

  // eslint-disable-next-line class-methods-use-this
  scrollTabToTop(tab) {
    // const header = document.getElementById('shopify-section-header')
    // const borderOffset = header
    //   .querySelector('.header-wrapper')
    //   .classList.contains('header-wrapper--border-bottom')
    //   ? 1
    //   : 0
    // const headerHeight = header.getBoundingClientRect().bottom - borderOffset
    // const tabSummary = tab.querySelector('summary')
    const tabContent = tab.querySelector('.tab__content')
    // we are hardcoding the header height as it is not getting a height wgen hidden off screen
    const scrollY =
      tabContent.getBoundingClientRect().top +
      tabContent.ownerDocument.defaultView.pageYOffset -
      112
    window.scrollTo(0, scrollY)
  }

  closeOpenedTabs(tab) {
    const openTabs = Array.from(this.tabs).filter(
      (el) => el !== tab && el.getAttribute('open') !== null
    )
    if (!openTabs.length) {
      return
    }
    const openTab = openTabs[0]
    this.closeOpenedTab(openTab)
    if (this.isMobile) {
      this.scrollTabToTop(tab)
    }
  }

  onClickTab(evt) {
    const { target } = evt
    let tab = null
    if (target.classList.contains('product-tab')) {
      tab = target
    } else {
      tab = target.closest('.product-tab')
    }
    if (tab.hasAttribute('open') && this.isDesktop) {
      evt.preventDefault()
    }
  }

  // Callback function to execute when mutations are observed
  onMutate(mutationList) {
    for (const { type, attributeName, target } of mutationList) {
      // if (mutation.type === 'childList') {
      //   // console.log('A child node has been added or removed.')
      // } else  if (mutation.type === 'attributes') {
      //   console.log(`The ${mutation.attributeName} attribute was modified.`);
      // }
      if (
        type === 'attributes' &&
        attributeName === 'open' &&
        target.getAttribute('open') !== null
      ) {
        this.closeOpenedTabs(target)
      }
    }
  }

  setObserver(target, index) {
    const observer = new MutationObserver(this.onMutate.bind(this))
    observer.observe(target, {
      attributes: true,
      childList: false,
      subtree: false,
    })
    this.observers.push({ [index]: observer })
  }

  customProductTabs(){
    document.addEventListener('DOMContentLoaded', function () {
      function showTab() {
        document.querySelectorAll('.tab-title').forEach((tab) => {
          tab.addEventListener('click', function () {
            const href = this.getAttribute('data-href');
            document.querySelectorAll('.tab').forEach((tab) => tab.classList.remove('is-active'));
            this.parentElement.classList.add('is-active');
            document.querySelectorAll('.tab-content').forEach((content) => content.classList.remove('is-active'));
            document.querySelector(href).classList.add('is-active');
          })
        })
        document.querySelectorAll('.toggleLink').forEach((toggle) => {
          toggle.addEventListener('click', function () {
            const tabParent = this.parentElement.parentElement;
            if (tabParent.classList.contains('is-active')) {
              tabParent.classList.remove('is-active');
              document.querySelectorAll('.tab').forEach((tab) => tab.classList.remove('is-active'));
              document.querySelectorAll('.tab-content').forEach((content) => content.classList.remove('is-active'));
            } else {
              tabParent.classList.add('is-active');
              document.querySelectorAll('.tab').forEach((tab) => tab.classList.remove('is-active'));
              const id = tabParent.getAttribute('id');
              document.getElementById(id).click();
              document.querySelectorAll('.tab-content').forEach((content) => content.classList.remove('is-active'));
              tabParent.classList.add('is-active');
            }
          })
        })
      }
      showTab()
    })
  }

  handleProductFAQs() {
    const faqTables = document.querySelectorAll('.product-faqs table');

    if(faqTables.length) {
      faqTables.forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('custom-table');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }
  }


  // RATING SCROLL ON CLICK
  reviewClickScroll() {
    const reviewClick = document.querySelector('.hoselink-rating-summary')
    const reviewSection = document.getElementById('productTabs')
    const reviewTab_desktop = document.querySelector('.tab-title.summary--reviews')
    const reviewTab_mobile = document.querySelector('.tab-content .summary--reviews')

    if (reviewClick != null) {
      reviewClick.onclick = (e) => {
        // Check if click was inside Okendo area or the wrapper
        const clickedOkendo = e.target.closest('.hoselink-rating-summary')
        if (!clickedOkendo) return
        
        e.preventDefault()
        reviewSection.scrollIntoView({behavior: "smooth"})
        
        reviewTab_mobile.click()
        reviewTab_desktop.click()
      };
    }
  }

  init() {
    this.customProductTabs()
    this.handleProductFAQs()
    this.reviewClickScroll()

    // this.tabs.addEventListener('click', this.onclick())
    this.mediaQuery = window.matchMedia('(min-width: 750px)')
    this.isDesktop = this.mediaQuery.matches
    this.isMobile = !this.mediaQuery.matches
    this.tabs = this.querySelectorAll('details')
    if (this.tabs.length === 0) {
      return
    }
    this.observers = []
    Array.from(this.tabs).forEach((tab, index) => {
      const summary = tab.querySelector('summary')
      summary.addEventListener('click', this.onClickTab.bind(this))
      this.setObserver(tab, index)
    })
  }
}

customElements.define('product-tabs', ProductTabs)

// KLAVIYO BACK IN STOCK
function backInStock() {
  const backInStockButton = document.getElementById('backInStockButtonForm')
  const backInStockemailInput = document.getElementById('backInStockEmail')
  const emailError = document.getElementById('backInStockemailError')
  const thankYouMessage = document.getElementById('thankYouMessage')
  const backInStockField = document.getElementById('backinStockField')

  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    return emailRegex.test(email)
  }

  backInStockButton.onclick = () => {
    const enteredEmail = backInStockemailInput.value.trim();
    if (isValidEmail(enteredEmail)) {
      emailError.textContent = ''
      backInStockButton.setAttribute('disabled', 'disabled')
      backInStockButton.innerHTML = '<span class="spinner"></span> Submitting...'
      submitForm(enteredEmail)
    } else {
      emailError.textContent = 'Invalid email address.'
    }
  }

  function submitForm(enteredEmail) {
    const variantID = document.getElementById('productID').value
    const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Qz5HTm'
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2023-09-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: `${enteredEmail}` // Use template literals to include the value
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantID}`
              }
            }
          }
        }
      })
    }

    fetch(url, options)
    .then(response => response.json())
    .then(response => {
      try {
          const parsedResponse = JSON.parse(response)
          console.log(parsedResponse);
      } catch (error) {
          console.error('Error parsing JSON:', error);
      }
    })
    .catch(err => console.error(err));
  
    setTimeout(() => {
      // Display the thank you message and hide the form and spinner
      backInStockField.style.display = 'none'
      backInStockButton.style.display = 'none'
      thankYouMessage.classList.remove('hidden')
    }, 2000)
  }
} 

function openBackInStockModal() {
  const modal = document.getElementById('backInStockModal')
  const openModalBtn = document.getElementById('backInStockButtonOpen')
  const closeModalBtn = document.getElementById('backInStockButtonClose')

  openModalBtn.addEventListener('click', function () {
      const variantName = document.getElementById('productVariantTitle').value

      if (variantName != 'Default Title'){
        const outputVariantName = document.getElementById('backInStockVariantTitle')
        outputVariantName.textContent = variantName;
      }
    
      modal.style.display = "block";
  });

  closeModalBtn.addEventListener("click", function() {
      modal.style.display = "none";
  });

  window.addEventListener("click", function(event) {
      if (event.target === modal) {
          modal.style.display = "none";
      }
  });
}

openBackInStockModal()
backInStock()
// END RATING SCROLL ON CLICK
class ReadMore extends HTMLElement {
  constructor() {
    super()
    this.tabs = []
    this.OPEN_ATTR = 'open'
    this.descriptionWrap = document.getElementById('productDescription')
    this.readMoreBtn = document.getElementById('readMore')
    this.hasEventListener = false
    this.init()
    window.addEventListener('resize', this.init.bind(this))
  }

  isOpen() {
    return this.descriptionWrap.hasAttribute(this.OPEN_ATTR)
  }

  close() {
    const { openText } = this.readMoreBtn.dataset
    this.descriptionWrap.removeAttribute(this.OPEN_ATTR)
    this.readMoreBtn.textContent = openText
  }

  open() {
    const { closeText } = this.readMoreBtn.dataset
    this.descriptionWrap.setAttribute(this.OPEN_ATTR, '')
    this.readMoreBtn.textContent = closeText
  }

  onClick(evt) {
    evt.preventDefault()
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  needsReadMore({ height = 0, scrollHeight = 0 } = this.dims) {
    return Math.round(height) < scrollHeight
  }

  setOpenHeight() {
    this.descriptionWrap.style.cssText = `--open-height: ${this.dims.scrollHeight}px;`
    this.readMoreBtn.classList.remove('hidden')
  }

  unsetMaxHeight() {
    this.descriptionWrap.style.cssText = '--max-height: auto;'
    this.readMoreBtn.classList.add('hidden')
  }

  init() {
    if (this.descriptionWrap === null || this.readMoreBtn === null) {
      return
    }
    const { height } = this.descriptionWrap.getBoundingClientRect()
    this.dims = {
      scrollHeight: this.descriptionWrap.scrollHeight,
      height,
    }
    const needsReadMore = this.needsReadMore()
    if (needsReadMore) {
      this.setOpenHeight()
      if (!this.hasEventListener) {
        this.hasEventListener = true
        this.readMoreBtn.addEventListener('click', this.onClick.bind(this))
      }
    } else {
      this.unsetMaxHeight()
      if (this.hasEventListener) {
        this.hasEventListener = false
        this.readMoreBtn.removeEventListener('click', this.onClick.bind(this))
      }
    }
  }
}

customElements.define('read-more', ReadMore)

class WhatsIncluded extends HTMLElement {
  constructor() {
    super()
    this.links = []
    this.setSlides()
    this.init()
  }

  setSlides() {
    this.slides = Array.from(this.querySelectorAll('.slideshow__slide'))
  }

  close(el) {
    el.classList.remove('tab__link--active')
    const targetId = el.hash
    const target = this.querySelector(targetId)
    target.removeAttribute('open')
  }

  open(el) {
    el.classList.add('tab__link--active')
    const target = this.querySelector(el.hash)
    target.setAttribute('open', '')
    this.setSlides()
    const slideParent = target.parentElement
    this.currentIndex = this.slides.findIndex((slide) => slide === target)
    slideParent.scrollLeft = target.offsetLeft
    this.currentIndex = this.slides.findIndex((slide) => slide === target)
    slideParent.scrollLeft = target.offsetLeft
    const tabParent = el.closest('ul')
    tabParent.scrollLeft = el.offsetLeft
  }

  closeOpen(link) {
    const other = this.links.filter((child) => child !== link)
    other.forEach((el) => {
      this.close(el)
    })
  }

  changeOpen(target) {
    this.closeOpen(target)
    this.open(target)
  }

  onTabClick(evt) {
    const { target } = evt
    evt.preventDefault()
    this.changeOpen(target)
  }

  moveSlide(direction) {
    const maxIndex = this.slides.length - 1
    if (direction === 'next') {
      this.currentIndex =
        this.currentIndex === maxIndex ? 0 : this.currentIndex + 1
    }
    if (direction === 'previous') {
      this.currentIndex =
        this.currentIndex === 0 ? maxIndex : this.currentIndex - 1
    }
  }

  onSliderButtonClick(evt) {
    const { target } = evt
    evt.preventDefault()
    const direction = target.getAttribute('name')
    this.moveSlide(direction)
    const tab = this.links[this.currentIndex]
    this.changeOpen(tab)
  }

  init() {
    this.currentIndex = 0
    this.sliderButtons = Array.from(this.querySelectorAll('.slider-button'))
    this.links = Array.from(this.querySelectorAll('.tab__link'))
    if (this.links.length === 0) {
      return
    }
    this.sliderButtons.forEach((button) => {
      button.addEventListener('click', this.onSliderButtonClick.bind(this))
    })
    this.links.forEach((link) => {
      link.addEventListener('click', this.onTabClick.bind(this))
    })
  }
}

customElements.define('whats-included', WhatsIncluded)
